/* fbt-pro.js (PRO v4.9 UX - Premium Quick View with Native Cart Sync) */
(function () {
  "use strict";

  function qs(root, sel) { return (root || document).querySelector(sel); }
  function qsa(root, sel) { return Array.from((root || document).querySelectorAll(sel)); }

  function toInt(v, fallback) {
    var n = parseInt(String(v || "").replace(/[^\d-]/g, ""), 10);
    return Number.isFinite(n) ? n : (fallback || 0);
  }

  // تم إضافة الدالة المفقودة هنا لتفادي الخطأ
  function splitLines(str) {
    if (!str) return [];
    return String(str).split(/[\n|;]+/).map(function(s) { return s.trim(); }).filter(Boolean);
  }

  function moneyFormatFromRoot(root) {
    return root.getAttribute("data-money-format") || "{{amount}}";
  }

  function formatMoney(cents, moneyFormat) {
    var format = moneyFormat || "{{amount}}";
    var value = (cents || 0) / 100;

    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";
      precision = precision == null ? 2 : precision;
      var s = (n || 0).toFixed(precision);
      var parts = s.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    var out;
    if (format.indexOf("amount_no_decimals_with_comma_separator") > -1) {
      out = withDelims(value, 0, ".", ",");
    } else if (format.indexOf("amount_with_comma_separator") > -1) {
      out = withDelims(value, 2, ".", ",");
    } else if (format.indexOf("amount_no_decimals") > -1) {
      out = withDelims(value, 0, ",", ".");
    } else {
      out = withDelims(value, 2, ",", ".");
    }
    return format.replace(/\{\{\s*amount.*?\s*\}\}/, out);
  }

  function openCartDrawerBestEffort() {
    try {
      if (window.theme && window.theme.cartDrawer && typeof window.theme.cartDrawer.open === "function") {
        window.theme.cartDrawer.open();
        return true;
      }
    } catch (e) {}

    try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("cart:open")); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent("hdt:cart:open")); } catch (e) {}

    var btn = document.querySelector('[data-cart-drawer-open],[data-drawer-trigger="cart"],a[href="/cart"],button[name="checkout"],.hdt-icon-cart');
    if (btn && btn.click) {
      try { btn.click(); return true; } catch (e) {}
    }
    return false;
  }

  // ==========================================
  // PREMIUM CUSTOM QUICK VIEW SYSTEM (JSON)
  // ==========================================
  document.addEventListener("click", function(e) {
    var target = e.target.closest('a.js-fbt-click-target');
    if (!target) return;

    var action = target.getAttribute('data-action');
    if (action === 'quick_view') {
      e.preventDefault();
      e.stopPropagation();
      openPremiumQuickView(target.href);
    }
  });

  function openPremiumQuickView(url) {
    var handleMatch = url.match(/\/products\/([^\/\?#]+)/);
    if (!handleMatch) {
      window.location.href = url;
      return;
    }
    var handle = handleMatch[1];
    var modalId = 'fbt-ajax-qv';
    var modal = document.getElementById(modalId);
    
    if (!modal) {
      modal = document.createElement('div');
      modal.id = modalId;
      modal.innerHTML = `
        <div class="fbt-uqv-overlay"></div>
        <div class="fbt-uqv-wrap">
          <button class="fbt-uqv-close" aria-label="Close">&times;</button>
          <div class="fbt-uqv-body"></div>
        </div>
      `;
      var style = document.createElement('style');
      style.innerHTML = `
        #fbt-ajax-qv { position: fixed; inset: 0; z-index: 2147483647; display: flex; align-items: center; justify-content: center; opacity: 0; visibility: hidden; transition: all 0.3s ease; font-family: inherit; }
        #fbt-ajax-qv.is-visible { opacity: 1; visibility: visible; }
        .fbt-uqv-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.6); backdrop-filter: blur(4px); }
        .fbt-uqv-wrap { position: relative; width: 95%; max-width: 900px; max-height: 90vh; background: #fff; border-radius: 12px; box-shadow: 0 20px 50px rgba(0,0,0,0.2); display: flex; flex-direction: column; transform: translateY(30px); transition: transform 0.3s ease; overflow: hidden; }
        #fbt-ajax-qv.is-visible .fbt-uqv-wrap { transform: translateY(0); }
        .fbt-uqv-close { position: absolute; top: 15px; right: 15px; width: 36px; height: 36px; border-radius: 50%; background: #f5f5f5; border: none; display: flex; align-items: center; justify-content: center; font-size: 24px; cursor: pointer; z-index: 999; transition: background 0.2s; color: #000; }
        .fbt-uqv-close:hover { background: #e0e0e0; }
        .fbt-uqv-body { flex: 1; width: 100%; height: 100%; overflow-y: auto; padding: 30px; }
        .fbt-uqv-loader { position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); display: flex; flex-direction: column; align-items: center; }
        .fbt-uqv-spinner { width: 40px; height: 40px; border: 3px solid #f3f3f3; border-top: 3px solid #000; border-radius: 50%; animation: fbt-spin 1s linear infinite; }
        @keyframes fbt-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

        /* Premium Quick View Internal Styles */
        .fbt-pq-wrap { display: flex; gap: 30px; }
        .fbt-pq-gallery { width: 50%; }
        .fbt-pq-info { width: 50%; display: flex; flex-direction: column; justify-content: center; }
        .fbt-pq-title { font-size: 24px; font-weight: 600; margin-bottom: 10px; color: #000; line-height: 1.3; }
        .fbt-pq-price-row { display: flex; align-items: center; gap: 12px; margin-bottom: 15px; }
        .fbt-pq-price { font-size: 24px; font-weight: 700; color: #e70000; }
        .fbt-pq-compare { font-size: 16px; text-decoration: line-through; color: #888; }
        .fbt-pq-desc { font-size: 15px; color: #555; margin-bottom: 25px; line-height: 1.6; max-height: 120px; overflow: hidden; display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; }
        .fbt-pq-variants select { width: 100%; padding: 14px 15px; border: 1px solid #ddd; border-radius: 8px; margin-bottom: 20px; font-size: 16px; outline: none; transition: border-color 0.3s; cursor: pointer; background: #fafafa; }
        .fbt-pq-variants select:focus { border-color: #000; }
        .fbt-pq-action { display: flex; gap: 15px; margin-bottom: 25px; }
        .fbt-pq-qty { width: 80px; padding: 14px; border: 1px solid #ddd; border-radius: 8px; text-align: center; font-size: 16px; outline: none; font-weight: bold;}
        .fbt-pq-btn { flex: 1; background: #000; color: #fff; border: none; border-radius: 8px; font-size: 16px; font-weight: 700; cursor: pointer; transition: background 0.3s, transform 0.1s; display: flex; align-items: center; justify-content: center; letter-spacing: 1px; }
        .fbt-pq-btn:hover { background: #333; }
        .fbt-pq-btn:active { transform: scale(0.98); }
        .fbt-pq-btn:disabled { background: #ccc; cursor: not-allowed; }
        .fbt-pq-trust { display: flex; justify-content: space-between; border-top: 1px solid #eee; padding-top: 20px; font-size: 14px; color: #444; font-weight: 500; }
        .fbt-pq-main-img { width: 100%; border-radius: 12px; object-fit: contain; background: #f9f9f9; aspect-ratio: 1; margin-bottom: 15px; border: 1px solid #eee; }
        .fbt-pq-thumbs { display: flex; gap: 12px; overflow-x: auto; padding-bottom: 5px; scrollbar-width: none; }
        .fbt-pq-thumbs::-webkit-scrollbar { display: none; }
        .fbt-pq-thumb { width: 70px; height: 70px; border-radius: 8px; object-fit: cover; cursor: pointer; border: 2px solid transparent; transition: border-color 0.2s; background: #f9f9f9; }
        .fbt-pq-thumb.is-active { border-color: #000; }
        
        @media (max-width: 768px) {
          .fbt-uqv-body { padding: 20px; }
          .fbt-pq-wrap { flex-direction: column; gap: 20px; }
          .fbt-pq-gallery, .fbt-pq-info { width: 100%; }
          .fbt-pq-title { font-size: 20px; }
          .fbt-pq-trust { flex-direction: column; gap: 10px; align-items: center; }
        }
      `;
      document.head.appendChild(style);
      document.body.appendChild(modal);

      modal.querySelector('.fbt-uqv-overlay').addEventListener('click', closeUQV);
      modal.querySelector('.fbt-uqv-close').addEventListener('click', closeUQV);
    }

    function closeUQV() {
      modal.classList.remove('is-visible');
      setTimeout(function() {
        modal.querySelector('.fbt-uqv-body').innerHTML = ''; 
        document.body.style.overflow = '';
      }, 300);
    }

    var body = modal.querySelector('.fbt-uqv-body');
    body.innerHTML = '<div class="fbt-uqv-loader"><div class="fbt-uqv-spinner"></div></div>';
    
    document.body.style.overflow = 'hidden'; 
    void modal.offsetWidth;
    modal.classList.add('is-visible');

    var rootObj = document.querySelector('[data-fbt-root]');
    var moneyFormat = rootObj ? (rootObj.getAttribute("data-money-format") || "${{amount}}") : "${{amount}}";
    var shopifyRoot = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

    fetch(shopifyRoot + 'products/' + handle + '.js')
      .then(function(res) {
        if (!res.ok) throw new Error("Fetch failed");
        return res.json();
      })
      .then(function(product) {
        var tempDiv = document.createElement("div");
        tempDiv.innerHTML = product.description || '';
        var rawDesc = tempDiv.textContent || tempDiv.innerText || "";
        var shortDesc = rawDesc.substring(0, 150) + (rawDesc.length > 150 ? '...' : '');

        var mainImage = product.featured_image || '//cdn.shopify.com/s/images/themes/product-1.png';
        var thumbHtml = '';
        if (product.images && product.images.length > 1) {
          product.images.forEach(function(img, i) {
             thumbHtml += `<img src="${img}" class="fbt-pq-thumb ${i === 0 ? 'is-active' : ''}" data-src="${img}">`;
          });
        }

        var hasMultipleVariants = product.variants && product.variants.length > 1;
        var variantsOptions = '';
        var initialVariant = null;

        if (product.variants && product.variants.length > 0) {
          initialVariant = product.variants.find(function(v) { return v.available; }) || product.variants[0];
          product.variants.forEach(function(v) {
             var isAvailable = v.available ? '' : ' - (Out of Stock)';
             var priceStr = formatMoney(v.price, moneyFormat);
             var selected = (v.id === initialVariant.id) ? 'selected' : '';
             variantsOptions += `<option value="${v.id}" data-price="${v.price}" data-compare="${v.compare_at_price || v.price}" data-img="${v.featured_image ? v.featured_image.src : ''}" ${!v.available ? 'disabled' : ''} ${selected}>${v.title} - ${priceStr}${isAvailable}</option>`;
          });
        }

        var variantHtml = hasMultipleVariants ?
          `<div class="fbt-pq-variants"><select name="id" class="fbt-pq-select">${variantsOptions}</select></div>` : 
          `<input type="hidden" name="id" value="${initialVariant ? initialVariant.id : ''}">`;

        var currentPrice = initialVariant ? formatMoney(initialVariant.price, moneyFormat) : '';
        var comparePrice = (initialVariant && initialVariant.compare_at_price > initialVariant.price) ? formatMoney(initialVariant.compare_at_price, moneyFormat) : '';

        var html = `
          <div class="fbt-pq-wrap">
            <div class="fbt-pq-gallery">
              <img src="${mainImage}" class="fbt-pq-main-img" id="fbt-pq-main-img">
              <div class="fbt-pq-thumbs">${thumbHtml}</div>
            </div>
            <div class="fbt-pq-info">
              <h2 class="fbt-pq-title">${product.title}</h2>
              <div class="fbt-pq-price-row">
                <span class="fbt-pq-price" id="fbt-pq-price">${currentPrice}</span>
                <span class="fbt-pq-compare" id="fbt-pq-compare">${comparePrice}</span>
              </div>
              <div class="fbt-pq-desc">${shortDesc}</div>
              <form id="fbt-pq-form">
                ${variantHtml}
                <div class="fbt-pq-action">
                  <input type="number" name="quantity" class="fbt-pq-qty" value="1" min="1">
                  <button type="submit" class="fbt-pq-btn" ${!initialVariant || !initialVariant.available ? 'disabled' : ''}>
                     <span class="fbt-pq-btn-text">${initialVariant && initialVariant.available ? 'ADD TO CART' : 'SOLD OUT'}</span>
                  </button>
                </div>
              </form>
              <div class="fbt-pq-trust">
                <span><span style="color:#00a86b">●</span> In Stock</span>
                <span>🔒 Secure Checkout</span>
                <span>🚚 Fast Shipping</span>
              </div>
            </div>
          </div>
        `;

        body.innerHTML = html;

        var thumbs = body.querySelectorAll('.fbt-pq-thumb');
        var mainImgEl = body.querySelector('#fbt-pq-main-img');

        thumbs.forEach(function(t) {
           t.addEventListener('click', function() {
              thumbs.forEach(function(el) { el.classList.remove('is-active'); });
              this.classList.add('is-active');
              mainImgEl.src = this.getAttribute('data-src');
           });
        });

        var select = body.querySelector('.fbt-pq-select');
        if (select) {
           select.addEventListener('change', function() {
              var opt = this.options[this.selectedIndex];
              body.querySelector('#fbt-pq-price').innerHTML = formatMoney(toInt(opt.getAttribute('data-price'), 0), moneyFormat);
              var comp = toInt(opt.getAttribute('data-compare'), 0);
              var pr = toInt(opt.getAttribute('data-price'), 0);
          
              body.querySelector('#fbt-pq-compare').innerHTML = comp > pr ? formatMoney(comp, moneyFormat) : '';
              
              var imgSrc = opt.getAttribute('data-img');
              if (imgSrc && imgSrc !== 'null' && imgSrc !== '') {
                 mainImgEl.src = imgSrc;
             
                 var baseImg = imgSrc.split('?')[0];
                 thumbs.forEach(function(el) {
                    if (el.getAttribute('data-src').indexOf(baseImg) > -1) {
                       thumbs.forEach(function(t) { t.classList.remove('is-active'); });
                       el.classList.add('is-active');
                    }
                 });
              }
           });
        }

        // Add to Cart Logic FOR QUICK VIEW
        var form = body.querySelector('#fbt-pq-form');

        form.addEventListener('submit', async function(e) {
           e.preventDefault();
           var btn = form.querySelector('.fbt-pq-btn');
           var btnText = btn.querySelector('.fbt-pq-btn-text');
           
           btnText.innerHTML = 'Adding...';
           btn.style.opacity = '0.7';
           btn.disabled = true;

           var vid = parseInt(form.querySelector('[name="id"]').value);
           var vqty = parseInt(form.querySelector('[name="quantity"]').value);

           var addBody = { items: [{ id: vid, quantity: vqty }] };

           var cartDrawerSectionId = null;
           var headerSectionId = null;
           try {
             var cdEl = document.querySelector("hdt-cart-drawer");
  
             if (cdEl) cartDrawerSectionId = cdEl.getAttribute("section-id");
             
             var hEl = document.querySelector("hdt-header, [id^='shopify-section-header']");
             if (hEl) headerSectionId = hEl.getAttribute("section-id") || hEl.id.replace('shopify-section-', '');
           } catch (err) {}

           var sectionsArray = [];

           if (cartDrawerSectionId) sectionsArray.push(cartDrawerSectionId);
           if (headerSectionId && headerSectionId !== cartDrawerSectionId) sectionsArray.push(headerSectionId);

           if (sectionsArray.length > 0) {
             addBody.sections = sectionsArray.join(',');
             addBody.sections_url = window.location.pathname;
           }

           try {
             var res = await fetch(shopifyRoot + 'cart/add.js', {
               method: 'POST',
               headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
               body: JSON.stringify(addBody)
             });
             
             var addJson = await res.json();
             if (!res.ok) throw new Error("Add failed");

             // Fetch full cart to properly update HDT Theme
             var cart = null;

             try {
               var cartRes = await fetch(shopifyRoot + 'cart.js', {
                 method: 'GET',
                 headers: { 'Accept': 'application/json' }
               });

               if (cartRes.ok) cart = await cartRes.json();
             } catch(e) {}

             // Trigger HDT native events
             try {
               document.dispatchEvent(new CustomEvent("cart:update", {
                 bubbles: true,
                 detail: {
                   resource: cart,
                   sourceId: "fbt-qv",
                   cartData: addJson,
                   actionAfterATC: "open_drawer",
                   data: { sections: (addJson && addJson.sections) ? addJson.sections : undefined }
                 }
               }));
             } catch(e) {}

             try { document.dispatchEvent(new CustomEvent("cart:reload", { bubbles: true })); } catch(err){}
             try { document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })); } catch(err){}
             try { document.dispatchEvent(new CustomEvent("hdt:cart:open", { bubbles: true })); } catch(err){}
             
             openCartDrawerBestEffort();

             btn.style.background = '#00a86b';
             btn.style.opacity = '1';
             btnText.innerHTML = 'Added! ✓';

             setTimeout(function(){
               closeUQV();
             }, 800);

           } catch (error) {
             btnText.innerHTML = 'Error! Try again';
             btn.style.opacity = '1';
             btn.disabled = false;
           }
        });
      })
      .catch(function(err) {
        window.location.href = url;
      });
  }

  // ==========================================
  // CORE FBT LOGIC
  // ==========================================
  function initRoot(root) {
    if (!root || root.__fbtInit) return;
    root.__fbtInit = true;

    var moneyFormat = moneyFormatFromRoot(root);
    var basePrice = toInt(root.getAttribute("data-base-price"), 0);
    var baseCompare = toInt(root.getAttribute("data-base-compare"), basePrice);

    var threshold = toInt(root.getAttribute("data-free-ship-threshold"), 0);
    var freeShipEnabled = String(root.getAttribute("data-free-ship-enabled")) === "true";

    var showDiscount = String(root.getAttribute("data-show-discount")) === "true";
    var showFomo = String(root.getAttribute("data-show-fomo")) === "true";
    var autoselect = toInt(root.getAttribute("data-autoselect"), 0);

    var checks = qsa(root, "[data-fbt-check]");
    var items = qsa(root, "[data-fbt-item]");
    var totalEl = qs(root, "[data-fbt-total]");
    var saveRow = qs(root, "[data-fbt-save]");
    var saveMoneyEl = qs(root, "[data-fbt-save-money]");
    var discountEl = qs(root, "[data-fbt-discount]");
    var hintEl = qs(root, "[data-fbt-hint]");
    var addBtn = qs(root, "[data-fbt-add]");
    var bestBtn = qs(root, "[data-fbt-best]");
    var freeShipWrap = qs(root, "[data-fbt-freeship]");
    var freeShipText = qs(root, "[data-fbt-freeship-text]");
    var freeShipBar = qs(root, "[data-fbt-bar]");

    var cdWrap = qs(root, "[data-fbt-countdown]");
    var cdTime = qs(root, "[data-fbt-cd-time]");
    var cdMode = root.getAttribute("data-countdown-mode") || "end_of_day";
    var cdHours = toInt(root.getAttribute("data-countdown-hours"), 6);

    var sectionId = root.getAttribute("data-section-id") || "";
    var baseVariantId = root.getAttribute("data-base-variant-id") || "";

    var fomoWrap = qs(root, "[data-fbt-fomo]");
    var fomoLine = qs(root, "[data-fbt-fomo-line]");
    var fomoLines = splitLines(root.getAttribute("data-fomo-texts") || "");

    function setHint(msg, ok) {
      if (!hintEl) return;
      hintEl.textContent = msg || "";
      hintEl.style.opacity = msg ? "1" : "";
      hintEl.style.color = ok === false ? "#b00020" : "";
    }

    function setTotal(totalCents) {
      if (totalEl) totalEl.innerHTML = formatMoney(totalCents, moneyFormat);
      var sticky = document.querySelector("[data-fbt-sticky-total]");
      if (sticky) {
        sticky.textContent = totalEl ? totalEl.textContent : "";
        sticky.hidden = false;
      }
    }

    function compute() {
      var total = basePrice;
      var compareTotal = baseCompare;

      items.forEach(function (item) {
        var chk = qs(item, "[data-fbt-check]");
        if (!chk || !chk.checked) return;

        var p = toInt(item.getAttribute("data-price"), 0);
        var c = toInt(item.getAttribute("data-compare"), p);
        total += p;
        compareTotal += c;

        var inv = toInt(item.getAttribute("data-inv"), 999999);
        var mini = qs(item, "[data-fbt-mini]");
  
        if (mini) {
          if (inv >= 0 && inv <= 5) {
            mini.textContent = "Only " + inv + " left";
            mini.hidden = false;
          } else {
            mini.hidden = true;
          }
        }
      });

      setTotal(total);

      var discountCode = root.getAttribute("data-discount-code") || "";
      var minForCode = toInt(root.getAttribute("data-discount-min-items"), 2);
      var tier2 = toInt(root.getAttribute("data-tier2"), 5);
      var tier3 = toInt(root.getAttribute("data-tier3"), 8);
      var tier4 = toInt(root.getAttribute("data-tier4"), 12);
      var selectedCount = 1; 
      items.forEach(function (item) {
        var chk2 = qs(item, "[data-fbt-check]");
        if (chk2 && chk2.checked) selectedCount++;
      });

      function tierPct(count) {
        if (count >= 4) return tier4;
        if (count >= 3) return tier3;
        if (count >= 2) return tier2;
        return 0;
      }

      var pct = tierPct(selectedCount);
      var unlockEl = qs(root, "[data-fbt-unlock]");
      var stickySaveRow = document.querySelector("[data-fbt-sticky-save]");
      var stickySaveMoney = document.querySelector("[data-fbt-sticky-save-money]");
      var stickyCode = document.querySelector("[data-fbt-sticky-code]");

      if (unlockEl) {
        if (discountCode && pct > 0 && selectedCount >= minForCode) {
          unlockEl.hidden = false;
          unlockEl.innerHTML = "🎁 <strong>" + pct + "% OFF</strong> unlocked. Code: <span class='code'>" + discountCode + "</span> (auto applied).";
        } else if (discountCode && pct > 0) {
          unlockEl.hidden = false;
          unlockEl.innerHTML = "Add 1 more item to unlock <strong>" + pct + "% OFF</strong> with code <span class='code'>" + discountCode + "</span>.";
        } else {
          unlockEl.hidden = true;
        }
      }

      var stickyTotal = document.querySelector("[data-fbt-sticky-total]");
      if (stickyTotal && totalEl) stickyTotal.textContent = totalEl.textContent;
      if (stickyCode) stickyCode.textContent = discountCode || "";

      if (stickySaveRow && discountCode && pct > 0) {
        stickySaveRow.hidden = false;
      } else if (stickySaveRow) {
        stickySaveRow.hidden = true;
      }

      if (stickySaveMoney && saveMoneyEl) stickySaveMoney.textContent = saveMoneyEl.textContent || "";

      var savings = Math.max(0, compareTotal - total);
      if (saveRow && saveMoneyEl) {
        if (savings > 0) {
          saveRow.hidden = false;
          saveMoneyEl.innerHTML = formatMoney(savings, moneyFormat);

          if (discountEl) {
            if (showDiscount && compareTotal > 0) {
              var discountPercent = Math.round((savings / compareTotal) * 100);
              discountEl.textContent = "-" + discountPercent + "%";
              discountEl.hidden = false;
            } else {
              discountEl.hidden = true;
            }
          }
        } else {
          saveRow.hidden = true;
          if (discountEl) discountEl.hidden = true;
        }
      }

      if (freeShipEnabled && freeShipWrap && freeShipText && freeShipBar && threshold > 0) {
        var progress = Math.min(1, total / threshold);
        freeShipBar.style.width = Math.round(progress * 100) + "%";
        if (total >= threshold) {
          freeShipText.textContent = "You unlocked free shipping";
        } else {
          var remain = threshold - total;
          freeShipText.textContent = "Add " + formatMoney(remain, moneyFormat) + " to get free shipping";
        }
      }
    }

    items.forEach(function (item) {
      item.addEventListener("click", function (e) {
        if (e.target.tagName.toLowerCase() === 'input') return;
        if (e.target.closest('.js-fbt-click-target')) return;

        var chk = qs(item, "[data-fbt-check]");
        if (chk && !chk.disabled) {
          chk.checked = !chk.checked;
          chk.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
    });

    if (autoselect) {
      var count = 0;
      for (var i = 0; i < items.length; i++) {
        var chk = qs(items[i], "[data-fbt-check]");
        if (!chk) continue;
        chk.checked = count < autoselect;
        count++;
      }
    }

    if (bestBtn) {
      bestBtn.addEventListener("click", function () {
        var count = 0;
        items.forEach(function (item) {
          var chk = qs(item, "[data-fbt-check]");
          if (!chk) return;
          chk.checked = count < 2;
          count++;
        });
        compute();
        setHint("Best bundle selected ✅", true);
        try { bestBtn.blur(); } catch(e){}
      });
    }

    checks.forEach(function (c) {
      c.addEventListener("change", compute);
    });

    compute();

    var sticky = document.querySelector("[data-fbt-sticky]");
    if (sticky) {
      var closeBtn = sticky.querySelector("[data-fbt-sticky-close]");
      var stickyAdd = sticky.querySelector("[data-fbt-sticky-add]");

      function hasAddonSelected() {
        return items.some(function (item) {
          var chk = qs(item, "[data-fbt-check]");
          return chk && chk.checked;
        });
      }

      function syncSticky() {
        var t = document.querySelector("[data-fbt-sticky-total]");
        if (t && totalEl) t.textContent = totalEl.textContent || "";
        var sm = sticky.querySelector("[data-fbt-sticky-save-money]");
        if (sm && saveMoneyEl) sm.textContent = saveMoneyEl.textContent || "";
        var code = sticky.querySelector("[data-fbt-sticky-code]");
        if (code) code.textContent = root.getAttribute("data-discount-code") || "";
      }

      if (closeBtn) closeBtn.addEventListener("click", function(){ sticky.hidden = true; });

      if (stickyAdd && addBtn) stickyAdd.addEventListener("click", function(){
        try{ addBtn.click(); }catch(e){}
      });

      var io = new IntersectionObserver(function(entries){
        var en = entries && entries[0];
        if (!en) return;
        if (en.isIntersecting) {
          sticky.hidden = true;
        } else {
          if (hasAddonSelected()) { syncSticky(); sticky.hidden = false; }
        }
      }, { rootMargin: "-20% 0px -60% 0px" });

      io.observe(root);
      checks.forEach(function (c) {
        c.addEventListener("change", function(){ syncSticky(); });
      });
    }

    if (showFomo && fomoWrap && fomoLine && fomoLines.length) {
      var baseViewers = 8 + Math.floor(Math.random() * 18);
      function renderFomo(line) {
        var viewers = baseViewers + Math.floor(Math.random() * 6);
        fomoLine.textContent = String(line).replace(/\{viewers\}/g, String(viewers));
        fomoWrap.hidden = false;
      }
      var fi = 0;
      renderFomo(fomoLines[0]);
      setInterval(function () {
        fi = (fi + 1) % fomoLines.length;
        renderFomo(fomoLines[fi]);
      }, 5000);
    }

    if (cdWrap && cdTime) {
      var enabled = String(root.getAttribute("data-countdown-enabled")) === "true";
      if (!enabled) { 
        cdWrap.hidden = true;
      } else {
        function pad(n) { return n < 10 ? "0" + n : "" + n; }
        var target;

        if (cdMode === "hours_from_view") {
          var key = "fbt_cd_" + sectionId + "_" + baseVariantId;
          var stored = toInt(localStorage.getItem(key), 0);
          var now = Date.now();
          if (!stored || stored < now) {
            stored = now + cdHours * 60 * 60 * 1000;
            try { localStorage.setItem(key, String(stored)); } catch (e) {}
          }
          target = stored;
        } else {
          var d = new Date();
          d.setHours(23, 59, 59, 999);
          target = d.getTime();
        }

        function tick() {
          var diff = Math.max(0, target - Date.now());
          var s = Math.floor(diff / 1000);
          var h = Math.floor(s / 3600);
          s -= h * 3600;
          var m = Math.floor(s / 60);
          s -= m * 60;
          cdTime.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
          if (diff <= 0) {
            cdWrap.hidden = true;
          }
        }
        tick();
        setInterval(tick, 1000);
      }
    }

    if (addBtn) {
      addBtn.addEventListener("click", async function () {
        if (addBtn.disabled) return;

        var originalText = addBtn.innerHTML;
        addBtn.innerHTML = "Adding...";
        addBtn.style.opacity = "0.7";
        addBtn.style.cursor = "wait";
        
        setHint("");
        addBtn.disabled = true;

        try {
          var payloadItems = [{ id: toInt(baseVariantId, 0), quantity: 1 }];

          items.forEach(function (item) {
            var chk = qs(item, "[data-fbt-check]");
            if (!chk || !chk.checked) return;
            var vid = toInt(item.getAttribute("data-variant-id"), 0);
            if (vid) payloadItems.push({ id: vid, quantity: 1 });
          });

          if (payloadItems.length <= 1) {
            setHint("Select at least one add-on item.", false);
            addBtn.innerHTML = originalText;
            addBtn.style.opacity = "1";
            addBtn.style.cursor = "pointer";
            addBtn.disabled = false;
            return;
          }

          var cartDrawerSectionId = null;
          try {
            var cdEl = document.querySelector("hdt-cart-drawer");
            if (cdEl) cartDrawerSectionId = cdEl.getAttribute("section-id");
          } catch (e) {}

          var addBody = { items: payloadItems };
          if (cartDrawerSectionId) {
            addBody.sections = String(cartDrawerSectionId);
            addBody.sections_url = window.location.pathname;
          }

          var res = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify(addBody)
          });

          var addJson = null;
          try { addJson = await res.json(); } catch (e) {}

          if (!res.ok) {
            var msg = (addJson && addJson.description) || (addJson && addJson.message) || "Cart error";
            throw new Error(msg);
          }

          var cart = null;
          try {
            var cartRes = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/") + "cart.js", {
              method: "GET",
              headers: { "Accept": "application/json" },
              credentials: "same-origin"
            });
            if (cartRes.ok) cart = await cartRes.json();
          } catch (e) {}

          try {
            document.dispatchEvent(new CustomEvent("cart:update", {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: "fbt-pro",
                cartData: addJson,
                actionAfterATC: "open_drawer",
                source: "fbt",
                data: { sections: (addJson && addJson.sections) ? addJson.sections : undefined }
              }
            }));
          } catch (e) {}

          try { document.dispatchEvent(new CustomEvent("cart:reload", { bubbles: true })); } catch (e) {}
          try { document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true })); } catch (e) {}

          openCartDrawerBestEffort();
          setHint("Added to cart ✅", true);

          try {
            var code = root.getAttribute("data-discount-code") || "";
            var minForCode = toInt(root.getAttribute("data-discount-min-items"), 2);
            var selectedCount = payloadItems.length;
            if (code && selectedCount >= minForCode) {
              var applyUrl = "/discount/" + encodeURIComponent(code) + "?redirect=/cart";
              try { await fetch(applyUrl, { credentials: "same-origin", redirect: "follow" }); } catch (e4) {}
              setHint("Discount code applied ✅ (" + code + ")", true);
            }
          } catch (e5) {}

        } catch (e) {
          setHint("Sorry, couldn't add bundle. Try again.", false);
        } finally {
          addBtn.innerHTML = originalText;
          addBtn.style.opacity = "1";
          addBtn.style.cursor = "pointer";
          setTimeout(function () { addBtn.disabled = false; }, 600);
        }
      });
    }
  }

  function boot() {
    qsa(document, "[data-fbt-root]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    var section = e && e.target ? e.target : document;
    qsa(section, "[data-fbt-root]").forEach(initRoot);
  });

})();